import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-failed-payments-filters',
  templateUrl: './failed-payments-filters.component.html',
  styleUrls: ['./failed-payments-filters.component.css']
})
export class FailedPaymentsFiltersComponent {
  @Output() filterChange = new EventEmitter<any>();
  filters = {
    statusFailed: true,
    statusProcessed: false,
    email: '',
    minAmount: 0,
    maxAmount: 0,
    dateFrom: '',
    dateTo: ''
  };
  onFilterChange() {
    this.filterChange.emit(this.filters);
  }
  clearFilters() {
    this.filters = {
      statusFailed: true,
      statusProcessed: false,
      email: '',
      minAmount: 0,
      maxAmount: 0,
      dateFrom: '',
      dateTo: ''
    };
    this.onFilterChange();
  }
}
